<template>
  <Layout :backToRoute="false" :backFrameRoute="backFrameRoute">
    <div class="primary--text section-title font-weight-bold">
      <v-icon color="primary">add_circle</v-icon>
      <span style="color: var(--primary-color-blue); font-size: 25px; font-weight: 700;">
        {{ $t("recharge.title") }}
      </span>
    </div>
    <v-text-field
      v-model="rechargeInputFormated"
      :placeholder="placeholder"
      @focus="placeholder = ''"
      @blur="placeholder = '0,00'"
      rounded
      hide-spin-buttons
      type="number"
      class="big-input pt-0 mb-7"
      :class="{ display: $vuetify.breakpoint.smAndUp }"
      :style="$vuetify.breakpoint.xsOnly ? 'font-size: 30px;' : ''"
    ></v-text-field>
    <v-row class="justify-space-between primary--text">
      <v-col class="d-flex flex-column">
        <span style="color: var(--primary-color-blue); font-size: 14px; font-weight: 300;">{{
          $t("recharge.current_balance")
        }}</span>
        <span class="font-weight-bold title" v-if="userData"
          ><span style="color: var(--primary-color-blue); font-size: 35px; font-weight: 600;"
            >{{ whole(userData.balance) }},</span
          ><span style="color: var(--primary-color-blue); font-size: 20px;">
            {{ decimal(userData.balance) }}
          </span>
          <v-icon style="color: var(--primary-color-blue); font-size: 14px; font-weight: 500;">{{ currency_symbol }}</v-icon></span
        >
      </v-col>
      <v-col class="d-flex flex-column text-end" :style="rechargeInputFormated > 0 ? 'color: #000230 !important;' : 'color: #00023033 !important;'">
        <span style="font-size: 14px; font-weight: 300;">{{
          $t("recharge.new_balance")
        }}</span>
        <span class="font-weight-bold title nowrap" v-if="userData">
          <span style="font-size: 35px; font-weight: 600;">{{ whole(newBalance) }},</span
          ><span style="font-size: 20px;">{{ decimal(newBalance) }}</span>
          <v-icon style="font-size: 14px; font-weight: 500;">{{ currency_symbol }}</v-icon>
        </span>
      </v-col>
    </v-row>
    <v-row class="align-center title mt-8">
      <v-col cols="12">
        <v-btn
          class="py-8 semi-rounded w-100"
          style="background: var(--primary-color-blue) !important; color: white;"
          x-large
          :disabled="!rechargeInput"
          @click="
            $router.push({
              name: routeNames.RECHARGE_PAYMENT,
              params: {
                amount: rechargeInput,
                paymentMethod: selectedPaymentMethod,
                currency_symbol,
              },
            })
          "
        >
          {{ $t("actions.confirm_select") }}
        </v-btn>
      </v-col>
      <v-col cols="12">
        <div
          class="py-2 text-center"
          style="cursor: pointer; color: var(--primary-color-blue); text-decoration: underline;"
          @click="$router.push({ name: routeNames.WALLET })"
        >
          {{ $t("actions.cancel") }}
        </div>
      </v-col>
    </v-row>
    
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/MainLayout";
import { mapState } from "vuex";
import { whole, decimal, limitDecimals } from "../utils/MoneyUtils";
import PaymentDataMixin from "@/mixins/PaymentData";
import { RequestService } from "../services/request.service";

const requestService = new RequestService();
export default {
  props: ["routeNames"],
  data() {
    return {
      rechargeInput: null,
      placeholder: "0,00",
      backFrameRoute: null,
    };
  },
  mixins: [PaymentDataMixin],
  components: {
    Layout,
  },
  methods: {
    whole,
    decimal,
    limitDecimals,
  },
  async beforeMount() {
    if (!this.userData) {
      const context = this;
      await requestService.getUserData(context);
    }
  },
  computed: {
    ...mapState({
      userData: (state) => state.userData.userData,
      currency_symbol: (state) =>
        state.customization.customization.economics.currency_symbol,
    }),
    newBalance() {
      return (
        this.userData.balance +
        Number((this.rechargeInputFormated * 100).toFixed())
      );
    },
    rechargeInputFormated: {
      get() {
        return this.rechargeInput;
      },
      set(newValue) {
        this.rechargeInput = this.limitDecimals(newValue);
      },
    },
  },
  mounted() {
    if (this.$route.query.badPaymentConfig)
      this.backFrameRoute = this.routeNames.WALLET;
  },
};
</script>
<style lang="css">
.big-input input {
  text-align: center;
  color: var(--primary-color-blue) !important;
  font-weight: 400;
}

.big-input .v-input__slot {
  border: 2px solid #0002301A !important;
  box-shadow: none !important;
  padding: 16px 0px !important;
}
</style>
